import { DotLoader } from "react-spinners";
import { useTheme } from "@hooks/useTheme";

const FullScreenDotLoader = ({
  loading = true,
  size = 80,
  color,
  speedMultiplier = 1,
  text = "Uploading verification file...",
  "data-testid": dataTestId = "full-screen-dot-loader",
}) => {
  const { colors } = useTheme();
  
  // Use theme color if no color is provided
  const loaderColor = color || colors.textActiveColor;

  if (!loading) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center ${colors.bgBlurModal}`}
      data-testid={`${dataTestId}-overlay`}
    >
      <div
        className={`rounded-lg shadow-2xl p-8 max-w-md mx-4 ${colors.bgBlurModal}`}
        data-testid={`${dataTestId}-dialog`}
      >
        <div className="flex flex-col items-center justify-center" data-testid={`${dataTestId}-body`}>
          <span data-testid={`${dataTestId}-dot-loader`}>
            <DotLoader
              color={loaderColor}
              loading={loading}
              size={size}
              speedMultiplier={speedMultiplier}
              aria-label="Loading"
            />
          </span>
          {text && (
            <p
              className={`mt-6 text-lg font-medium text-center ${colors.textPrimary}`}
              data-testid={`${dataTestId}-text`}
            >
              {text}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FullScreenDotLoader;
